import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { API, AuthContext } from '@/App';

// Fetches a user's profile photo as an authenticated blob (img tags cannot send
// headers). Falls back to initials. `bump` forces a refetch after upload/remove.
export const Avatar = ({ userId, hasPhoto, name, size = 40, bump = 0 }) => {
  const { token } = useContext(AuthContext);
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let revoked = null;
    setFailed(false);
    setUrl(null);
    if (userId && hasPhoto) {
      axios
        .get(`${API}/admin/users/${userId}/photo`, {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob',
        })
        .then((r) => {
          revoked = URL.createObjectURL(r.data);
          setUrl(revoked);
        })
        .catch(() => setFailed(true));
    }
    return () => { if (revoked) URL.revokeObjectURL(revoked); };
  }, [userId, hasPhoto, bump, token]);

  const initials = (name || '?')
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .trim()
    .split(/\s+/)
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

  const style = { width: size, height: size };

  if (url && !failed) {
    return (
      <img src={url} alt={name} style={style} data-testid="user-avatar-img"
        className="rounded-full object-cover border border-gray-200" />
    );
  }
  return (
    <div style={{ ...style, fontSize: size * 0.38 }} data-testid="user-avatar-initials"
      className="flex items-center justify-center rounded-full bg-[#0E2A47] font-bold text-white">
      {initials}
    </div>
  );
};

export default Avatar;
